import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import ui from './ui';
import auth from './auth';
import controls from './controls';
import profile from './profile';
import accounts from './accounts';
import company from './company';
import members from './members';
import reports from './reports';
import roles from './roles';
import invoices from './invoices';
import alerts from './alerts';
import documents from './documents';
import help from './help';
import splits from './splits';
import userTypes from './userTypes';
import me from './me/reducer';
import enrollments from './enrollments/reducer';
import dynamicReports from './dynamicReports/reducer';
import acknowledgements from './acknowledgements';
import caa204 from './caa204';

export default combineReducers({
  routing: routerReducer,
  form: formReducer,
  toastr: toastrReducer,
  ui,
  accounts,
  alerts,
  auth,
  company,
  controls,
  invoices,
  members,
  profile,
  reports,
  splits,
  roles,
  userTypes,
  documents,
  help,
  me,
  enrollments,
  dynamicReports,
  acknowledgements,
  caa204
});
